<script>
import BaseDialog from '@/components-v4/base-dialog.vue'
import LavenderMixin from '@/mixins/lavender'

export default {
  name: 'TamaraConfirmDialog',
  components: { BaseDialog },
  mixins: [LavenderMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClosed() {
      this.$emit('close')
    },
    onClickedCancel() {
      this.$emit('cancel')
    },
    onClickedConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<template>
  <BaseDialog v-model="visible" v-bind="$attrs" @click:outside="onClosed">
    <div :class="isLavenderReskinEnabled ? 'confirm-dialog-lavender' : ''">
      <div class="confirm-dialog-close-btn">
        <v-btn
          v-if="showCloseButton && !isLavenderReskinEnabled"
          fab
          small
          class="flex-grow-0 flex-shrink-0"
          color="white"
          @click="$emit('click:close')"
        >
          <SvgIcon size="20px" color="#000" name="close" />
        </v-btn>
      </div>
      <v-card class="px-5 py-5 px-sm-10 py-sm-10 confirm-dialog-content">
        <slot
          :on="{
            cancel: onClickedCancel,
            confirm: onClickedConfirm,
            showCloseButton,
          }"
        />
      </v-card>
    </div>
  </BaseDialog>
</template>
<style lang="scss" scoped>
.confirm-dialog-lavender {
  .confirm-dialog-content {
    border-radius: 32px 32px 0 0 !important;
  }
}

.confirm-dialog-close-btn {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
}

.confirm-dialog-content {
  border-radius: 14px 14px 0 0 !important;
}
</style>
